// Offsets like "fired 47 minutes ago" are anchored to page load, not to each
// render, so a row's time doesn't creep while the user reads it.
const LOADED_AT = Date.now()

export const demoLoadedAt = () => LOADED_AT
